class LocalStorage
{


    set(key, value) {
        
        window.localStorage.setItem(key, JSON.stringify(value));

        return this;
    }

    get(key) {

        const value = window.localStorage.getItem(key);

        try {
            return JSON.parse(value);
        } catch (e) {
            return value;
        }
    }

    remove(key) {
        window.localStorage.removeItem(
            key
        );
    }
}

export default LocalStorage;


// WEBPACK FOOTER //
// ./src/helpers/localstorage.js